// extracted by mini-css-extract-plugin
export default {"cardTableContainer":"cardtable_cardTableContainer__hqW2b"};